import { findPageRegrasDeInadimplencia, criarRegraDeInadimplencia, atualizarRegraDeInadimplencia } from "@/api/regraDeInadimplencia"
import { RegraDeInadimplencia } from "@/models"
import { RegraDeInadimplenciaServiceAdapter } from "@/usecases/titulos/adapter/RegraDeInadimplenciaServiceAdapter"
import { AxiosRequestConfig } from "axios"
import { injectable } from "inversify-props"

@injectable()
export class RegraDeInadimplenciaService implements RegraDeInadimplenciaServiceAdapter {
	findPageRegrasDeInadimplencia = async (params?: any, config?: AxiosRequestConfig) => await findPageRegrasDeInadimplencia(params, config)
	criarRegraDeInadimplencia = async (regraDeInadimplencia: RegraDeInadimplencia) => await criarRegraDeInadimplencia(regraDeInadimplencia)
	atualizarRegraDeInadimplencia = async (regraDeInadimplencia: RegraDeInadimplencia) => await atualizarRegraDeInadimplencia(regraDeInadimplencia)
}